import { createStore } from "@xstate/store";

export const notificationStore = createStore({
  context: {
    open: false,
  },
  on: {
    "notification.open": () => ({ open: true }),
    "notification.close": () => ({ open: false }),
    "notification.toggle": (ctx) => ({ open: !ctx.open }),
    "notification.setOpen": (_ctx, e: { open: boolean }) => ({ open: e.open }),
  },
});
